import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

type NewsroomLoadMoreButtonProps = {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

export function NewsroomLoadMoreButton({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: NewsroomLoadMoreButtonProps) {
  const { t } = useTranslation('regulatory-alerts')

  if (!hasNextPage) {
    return null
  }

  return (
    <Button
      variant='outline'
      disabled={isFetchingNextPage}
      onClick={onLoadMore}
    >
      {isFetchingNextPage ? (
        <Loader2 className='me-2 size-4 animate-spin' />
      ) : null}
      {t('inbox.loadMore')}
    </Button>
  )
}
